import { FC, SVGProps } from 'react';

const LogoutIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M14.0839 5.13025C15.5507 6.32307 16.4904 8.13315 16.4904 10.1755C16.4904 13.7609 13.5855 16.6658 10.0001 16.6658C6.41468 16.6658 3.50977 13.7609 3.50977 10.1755C3.50977 8.13315 4.4503 6.32307 5.91626 5.13025"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M10 3.33337V8.98887" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};

export default LogoutIcon;
